export default __webpack_public_path__ + "static/media/image-gran-espresso.fc5aa0dc.png";